<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="70%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <fg-input
              :label="`${$t('common_words.activity')}: *`"
              class="required-name"
              ref="name"
              type="text"
              v-model="model.name"
              v-validate="modelValidations.name"
              name="common_words.activity"
              :error="getError('common_words.activity', true)"
              :placeholder="`${$t('common_words.name')}`"
              @blur="convertUppercase(model.name)"
            >
            </fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <fg-input
              :label="`${$t('common_words.code')}: *`"
              class="required-code"
              ref="code"
              type="text"
              v-model="model.code"
              name="common_words.code"
              v-validate="modelValidations.code"
              :error="getError('common_words.code', true)"
              :placeholder="`${$t('common_words.code')}`"
            >
            </fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <fg-input
              :label="`${$t('common_words.code_homologated')}: `"
              class="required-homologacion"
              ref="code"
              type="text"
              v-model="model.homologated_code"
              :placeholder="`${$t('common_words.code_homologated')}`"
            ></fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <div class="form-group has-label">
              <label>{{ $t('labor.group_activities') }}*</label>
              <br />
              <el-select
                clearable
                collapse-tags
                filterable
                class="select-primary custom-width-select shadow-sm required-group_activities"
                size="large"
                v-model="model.activity_group_id"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="option in activityGroups"
                  class="select-primary"
                  :value="option.id"
                  :label="`${option.name}-${option.code}`"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            :class="
              model.watch_tracking
                ? 'col-6 col-sm-6 col-md-4 col-lg-6 col-xl-3'
                : 'col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4'
            "
          >
            <fg-input
              :label="`${$t('common_words.cost_center')}: `"
              class="required-cost_center"
              ref="cost_center"
              type="text"
              v-model="model.cost_center"
              :placeholder="`${$t('common_words.cost_center')}`"
            ></fg-input>
          </div>
          <div
            :class="
              model.watch_tracking
                ? 'col-6 col-sm-6 col-md-4 col-lg-6 col-xl-2'
                : 'col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4'
            "
          >
            <div class="has-label">
              <label>{{ $t('common_words.type_capture') }}?: *</label>
              <br />
              <el-select
                filterable
                class="select-primary custom-width-select mb-3 shadow-sm required-catch_type"
                v-model="model.catch_type"
                :placeholder="`${$t('common_words.select')}...`"
                style="width: 100%"
              >
                <el-option
                  class="select-primary"
                  v-for="item in [
                    { id: 'finca', value: 'Finca' },
                    { id: 'lote', value: 'Lote' },
                  ]"
                  :key="item.id + item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            v-show="model.watch_tracking"
            :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-3`"
          >
            <fg-input
              :label="`${$t('common_words.min_making_distance')}`"
              ref="min_making_distance"
              type="number"
              min="0"
              max="10"
              v-model="model.min_making_distance"
              :disabled="model.catch_type !== 'lote'"
              name="common_words.min_making_distance"
              v-validate="
                model.watch_tracking ? modelValidations.min_making_distance : {}
              "
              :error="getError('common_words.min_making_distance')"
              placeholder="..."
              @input="validateMinMakingDistance()"
              @change="validateMinMakingDistance()"
            ></fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-2`">
            <fg-input
              :label="`${$t('common_words.minimum')}: *`"
              step="0.01"
              min="0"
              ref="minimum"
              type="number"
              v-model="model.minimum"
              name="common_words.minimum"
              v-validate="modelValidations.minimum"
              :error="getError('common_words.minimum', true)"
              placeholder="..."
              @change="validateMinimum()"
            ></fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-2`">
            <fg-input
              :label="`${$t('common_words.maximum')}: *`"
              step="0.01"
              min="0"
              ref="maximum"
              type="number"
              v-model="model.maximum"
              name="common_words.maximum"
              v-validate="modelValidations.maximum"
              :error="getError('common_words.maximum', true)"
              placeholder="..."
              @change="validateMinimum()"
            ></fg-input>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <div class="form-group has-label">
              <label>{{ $t('common_words.payment_unit') }}*</label>
              <br />
              <el-select
                collapse-tags
                filterable
                class="select-primary custom-width-select shadow-sm required-payment_unit"
                size="large"
                v-model="model.payment_unit"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="option in activityUnits"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-4`">
            <div class="form-group has-label">
              <label>{{ $t('common_words.production_unit') }}*</label>
              <br />
              <el-select
                collapse-tags
                filterable
                class="select-primary custom-width-select shadow-sm required-production_unit"
                size="large"
                v-model="model.production_unit"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  v-for="option in activityUnits"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div :class="`col-4 col-md-4 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('labor.additional_activity') }}?</label>
              <el-switch
                v-model="model.aditional_activity"
                style="display: block; margin-top: 0.5rem"
                active-color="#6BA652"
                inactive-color="#ff4949"
              >
              </el-switch>
            </div>
          </div>
          <div :class="`col-4 col-md-4 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('labor.group_activities') }}?</label>
              <el-switch
                v-model="model.group_activities"
                style="display: block; margin-top: 0.5rem"
                active-color="#6BA652"
                inactive-color="#ff4949"
              >
              </el-switch>
            </div>
          </div>
          <div :class="`col-4 col-md-4 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('labor.assist_control') }}?</label>
              <el-switch
                v-model="model.assist_control"
                style="display: block; margin-top: 0.5rem"
                active-color="#6BA652"
                inactive-color="#ff4949"
              >
              </el-switch>
            </div>
          </div>
          <div :class="`col-4 col-md-4 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('labor.presentism') }}?</label>
              <el-switch
                v-model="model.presentism"
                style="display: block; margin-top: 0.5rem"
                active-color="#6BA652"
                inactive-color="#ff4949"
              >
              </el-switch>
            </div>
          </div>
          <div :class="`col-4 col-md-4 col-lg-3 col-xl-3`">
            <div class="form-group has-label">
              <label>{{ $t('common_words.traceable') }}</label>
              <br />
              <el-switch
                v-model="model.watch_tracking"
                :active-text="`${$t('common_words.yes')}`"
                :inactive-text="`${$t('common_words.no')}`"
                style="margin-left: 1rem"
                active-color="#6BA652"
                inactive-color="#ff4949"
              >
              </el-switch>
            </div>
          </div>
          <div :class="`col-12`">
            <select-businesses-component
              ref="selectBusiness"
              :showLoading="true"
              :requiered="true"
              :initialData="businessesInitial"
              @onChange="updateSelectedBusinesses"
              @showHideLoading="showHideLoading"
            />
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, convertFirstLetterUppercase } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create-activity',
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinValidations,
    MixinAlert,
    MixinPermissions,
  ],
  data() {
    return {
      disabledField: false,
      model: {
        name: null,
        code: null,
        homologated_code: null,
        cost_center: null,
        catch_type: null,
        minimum: null,
        maximum: null,
        activity_group_id: null,
        payment_unit: null,
        production_unit: null,
        aditional_activity: null,
        group_activities: null,
        assist_control: null,
        presentism: null,
        watch_tracking: 0,
        min_making_distance: null,
        businesses_id: [],
        businesses_names: [],
      },
      activityGroups: [],
      catchTypes: [],
      activityUnits: [],
      businessesInitial: [],
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
        minimum: {
          required: true,
          decimal: true,
        },
        maximum: {
          required: true,
          decimal: true,
        },
        min_making_distance: {
          min_value: 0,
          max_value: 10,
        },
      },
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
    'model.catch_type'(newValue) {
      if (newValue !== 'lote') {
        this.model.min_making_distance = null;
      }
    },
    'model.watch_tracking'(newValue) {
      if (!newValue) {
        this.model.min_making_distance = null;
      }
    },
  },
  methods: {
    convertUppercase(activityName) {
      const name = convertFirstLetterUppercase(activityName);
      this.model.name = name;
    },
    validateMinimum() {
      if (isset(this.model.minimum) && isset(this.model.maximum)) {
        if (Number(this.model.minimum) >= Number(this.model.maximum)) {
          SweetAlert.warning(i18n.t('labor.error_minimum_value'));
          let minumums = [...this.model.minimum];
          minumums = '';
          this.$set(this.model, 'minimum', minumums);
        }
      }
    },
    validateMinMakingDistance() {
      if (isset(this.model.min_making_distance)) {
        if (Number(this.model.min_making_distance) > 10) {
          this.model.min_making_distance = 10;
        } else if (Number(this.model.min_making_distance) < 0) {
          this.model.min_making_distance = 0;
        }
      }
    },
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.activity_group_id))
            return this.validationInputsRequired('group_activities');
          else if (!isset(this.model.catch_type))
            return this.validationInputsRequired('catch_type');
          else if (!isset(this.model.payment_unit))
            return this.validationInputsRequired('payment_unit');
          else if (!isset(this.model.production_unit))
            return this.validationInputsRequired('production_unit');
          else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.formatterDataModel();
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
    formatterDataModel() {
      if (!this.model.watch_tracking || this.model.catch_type !== 'lote') {
        this.model.min_making_distance = null;
      } else if (isset(this.model.min_making_distance)) {
        this.model.min_making_distance = Number(this.model.min_making_distance);
      }

      if (!isset(this.model.aditional_activity)) {
        this.model.aditional_activity = 0;
      } else this.model.aditional_activity = 1;

      if (!isset(this.model.group_activities)) {
        this.model.group_activities = 0;
      } else this.model.group_activities = 1;

      if (!isset(this.model.assist_control)) {
        this.model.assist_control = 0;
      } else this.model.assist_control = 1;

      if (!isset(this.model.presentism)) {
        this.model.presentism = 0;
      } else this.model.presentism = 1;
    },
  },
  mounted() {
    if (this.isCreate()) {
      Promise.all([
        Axios.getMasters('works/activityunits/field'),
        Axios.getMasters('works/activitiesgroups'),
      ])
        .then(([responseActivityUnits, responseActiviesGroups]) => {
          this.activityUnits = responseActivityUnits.data.data;
          this.activityGroups = responseActiviesGroups.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      const {
        business,
        businesses,
        assist_control,
        presentism,
        watch_tracking,
        group_activities,
        aditional_activity,
        min_making_distance,
      } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      this.$set(this.model, 'assist_control', assist_control ? true : false);
      this.$set(this.model, 'presentism', presentism ? true : false);
      this.$set(this.model, 'watch_tracking', watch_tracking ? true : false);
      this.$set(
        this.model,
        'group_activities',
        group_activities ? true : false
      );
      this.$set(
        this.model,
        'aditional_activity',
        aditional_activity ? true : false
      );
      this.$set(
        this.model,
        'min_making_distance',
        isset(min_making_distance) ? min_making_distance : null
      );

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
